import { Component, OnInit } from '@angular/core';
import { ThirdPartySource } from '../_types/third-party-source';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { ThirdPartiesSourcesService } from '../_services/third-party-source.service';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-third-parties-sources-list',
    templateUrl: './third-parties-sources-list.component.html',
    styleUrls: ['./third-parties-sources-list.component.scss'],
    host: { class: 'list-page' },
    standalone: false
})
export class ThirdPartiesSourcesListComponent implements OnInit {
  public thirdPartiesSources: ThirdPartySource[] = [];

  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name')
  };
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    public thirdPartiesSourcesService: ThirdPartiesSourcesService,
    private topbarService: TopbarService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) {  }

  ngOnInit(): void {
    this.topbarService.setTitle("Orígenes de clientes");
    this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
      this.edit({} as ThirdPartySource);
    });
    this.allowWrite = true;//this.loginService.hasPermission("PROVIDERS_WRITE")
    this.allowDelete = true;//this.loginService.hasPermission("PROVIDERS_DELETE")
  }

  public async loadData($event: any) {

    this.lastGridEvent = $event;

    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows }
    }

    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();

    let response = await firstValueFrom(this.thirdPartiesSourcesService.all(params));
    this.thirdPartiesSources = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
  }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(thirdPartySource: ThirdPartySource) {
    this.router.navigate(['thirdPartiesSources/' + (thirdPartySource && Object.keys(thirdPartySource).length > 0 ? thirdPartySource.id : 0)]);
  }

  delete(thirdPartySource: any) {
    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar el origen?",
        header: "Eliminar origen",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.thirdPartiesSourcesService.delete(thirdPartySource.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Origen eliminado correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        }
      });
    }
  }

}
